import React from 'react';
import { ArrowRight } from 'lucide-react';
import { scrollToSection } from '../lib/scroll';

const Hero = () => {
  return (
    <section id="inicio" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/hero-trabajo-industrial.jpg"
          alt="Andes Metal - Trabajo Industrial"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand/95 via-brand/85 to-brand/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Andes Metal - Excelencia en Metalmecánica Industrial en Mendoza
          </h1>
          <p className="text-lg sm:text-xl text-gray-200 mb-8 leading-relaxed">
            Más de 30 años de experiencia en fabricación de cubas para transformadores eléctricos con paneles aletados refrigerantes, galpones metálicos, estructuras metálicas y montajes industriales. Empresa metalmecánica líder en Mendoza, Argentina.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollToSection('servicios')}
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-brand font-semibold rounded-md hover:bg-gray-100 transition-all duration-300 group"
            >
              Nuestros Servicios
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white font-semibold rounded-md hover:bg-white hover:text-brand transition-all duration-300"
            >
              Contactar
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 hidden sm:flex">
        <div className="flex flex-col items-center animate-bounce">
          <span className="text-white text-sm mb-2">Descubre más</span>
          <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-white rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
